/* Mula Decor — scroll + interaction effects */
(function () {
  if (window.__mulaFx) return;
  window.__mulaFx = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io;

  function stagger(sel, step) {
    if (!io) return;
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('mula-rv')) continue;
      el.classList.add('mula-rv');
      if (step && el.parentElement) {
        var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
        el.style.setProperty('--rv-delay', Math.min(idx, 7) * step + 'ms');
      }
      io.observe(el);
    }
  }

  function sweep() {
    stagger('.mula-row__head', 0);
    stagger('.mula-chero__inner', 0);
    stagger('.mula-card', 55);
    stagger('.mula-tile', 40);
    stagger('.mula-split__media', 0);
    stagger('.mula-split__body', 90);
    stagger('.mula-promise > div', 80);
    stagger('.product-card', 50);
  }

  function init() {
    if (!reduce && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-in');
            io.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      sweep();
    }

    var hdr = document.getElementById('header-group');
    if (hdr) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          if (window.scrollY > 40) hdr.classList.add('mula-hdr-solid');
          else hdr.classList.remove('mula-hdr-solid');
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', sweep);
  document.addEventListener('shopify:section:select', sweep);
})();
